// extracted by mini-css-extract-plugin
export var blue = "_3s-g";
export var brand = "_3s-c";
export var darkGrey = "_3s-f";
export var disabled = "_3s-6";
export var disabledSubtle = "_3s-7";
export var error = "_3s-8";
export var green = "_3s-h";
export var grey = "_3s-e";
export var icon = "_3s-0";
export var inherit = "_3s-b";
export var lightGrey = "_3s-d";
export var orange = "_3s-j";
export var pink = "_3s-l";
export var primary = "_3s-1";
export var purple = "_3s-m";
export var quaternary = "_3s-4";
export var quinary = "_3s-5";
export var red = "_3s-k";
export var secondary = "_3s-2";
export var success = "_3s-a";
export var tertiary = "_3s-3";
export var warning = "_3s-9";
export var white = "_3s-n";
export var yellow = "_3s-i";